<template>
  <b-badge v-if="isMoney" :variant="variant" @click="$emit('click')" :href="clickable?'#':null"><h6 class="mb-1">{{moneyString}}</h6></b-badge>
  <b-badge v-else :variant="constant"><h6>{{naString}}</h6></b-badge>
</template>
<script>
import {moneyString, moneyStringWithoutCurrency} from '../../utils';

export default{
  props:{
    money: {
      type: Object
    }, 
    clickable: {
      type: Boolean,
      default:()=>false
    },
    withoutCurrency: {
      type: Boolean,
      default:()=>false
    }
  },
  computed: {
    variant(){
      if(this.money.amount>0) return 'green-700'
      else if(this.money.amount==0) return 'ow-secondary'
      return 'red-600'
    },
    isMoney(){
      if(this.money === null) return false
      if(
        typeof(this.money.amount)==='undefined' ||
        typeof(this.money.currency)==='undefined'
      ) return false
      return true
    },
    moneyString(){
      if(this.withoutCurrency) return moneyStringWithoutCurrency(this.money)
      return moneyString(this.money)
    },
      naString(){
          return '0.00'
      },
      constant(){
          return 'secondary'
      }
  }
}
</script>
